(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class StickyAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.announcementBar = document.querySelector('.section-announcement-bar');
      this.stickyAnnouncementBar = this.announcementBar.querySelector('sticky-announcement-bar');
      if (!this.stickyAnnouncementBar) return;
      this.announcementBarIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.announcementBarBounds = {};

      this.setAnnouncementBarHeight();

      const checkPhone = window.matchMedia('(max-width: 749px)');
      const checkTablet = window.matchMedia('(min-width: 750px) and (max-width: 989px)');
      const checkDesktop = window.matchMedia('(min-width: 990px)');

      checkPhone.addEventListener('change', this.setAnnouncementBarHeight.bind(this));
      checkTablet.addEventListener('change', this.setAnnouncementBarHeight.bind(this));
      checkDesktop.addEventListener('change', this.setAnnouncementBarHeight.bind(this));

      if (this.announcementBarIsAlwaysSticky) {
        this.announcementBar.classList.add('shopify-section-announcement-bar-sticky');
        document.body.classList.add('has-sticky-announcement-bar');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideAnnouncementBarOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventAnnouncementBarReveal', this.hideAnnouncementBarOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setAnnouncementBarHeight() {
      document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventAnnouncementBarReveal', this.hideAnnouncementBarOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.announcementBarBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.announcementBar);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.announcementBarBounds.bottom) {
        this.announcementBar.classList.add('scrolled-past-announcement-bar');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.announcementBarBounds.bottom) {
        this.announcementBar.classList.add('scrolled-past-announcement-bar');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.announcementBarBounds.top) {
        this.announcementBar.classList.remove('scrolled-past-announcement-bar');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.announcementBarIsAlwaysSticky) return;
      this.announcementBar.classList.add(
        'shopify-section-announcement-bar-hidden',
        'shopify-section-announcement-bar-sticky'
      );
      document.body.classList.remove('has-sticky-announcement-bar');
    }

    reveal() {
      if (this.announcementBarIsAlwaysSticky) return;
      this.announcementBar.classList.add('shopify-section-announcement-bar-sticky', 'animate');
      this.announcementBar.classList.remove('shopify-section-announcement-bar-hidden');
      document.body.classList.add('has-sticky-announcement-bar');
    }

    reset() {
      if (this.announcementBarIsAlwaysSticky) return;
      this.announcementBar.classList.remove(
        'shopify-section-announcement-bar-hidden',
        'shopify-section-announcement-bar-sticky',
        'animate'
      );
    }
  }

  customElements.define('sticky-announcement-bar', StickyAnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.setMenuDrawerHeaderBottomPosition();
      window.addEventListener('resize', this.setMenuDrawerHeaderBottomPosition);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setMenuDrawerHeaderBottomPosition() {
      const isTabletAndUp = window.matchMedia('(min-width: 750px)').matches;
      const menuOpenHeaderBottomPosition = isTabletAndUp ? 100 : 96;
      document.documentElement.style.setProperty(
        '--menu-open-header-bottom-position',
        `${parseInt(menuOpenHeaderBottomPosition)}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
